import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as PreviewArrowIcon } from "go-core/images/svg/actions/preview-arrow.svg";
import { DashboardAlertRowContent, DashboardAlertRowContentProps } from "./DashboardAlertRowContent";

export interface DashboardAlertRowProps extends DashboardAlertRowContentProps {
	link?: string;
}

export const DashboardAlertRow = ({ link, ...props }: DashboardAlertRowProps) => {
	if (link) {
		return (
			<Link to={link}>
				<div className="d-flex justify-content-between align-items-center overflow-x-auto">
					<DashboardAlertRowContent {...props} />
					<PreviewArrowIcon />
				</div>
			</Link>
		);
	}

	return (
		<div className="d-flex justify-content-between align-items-center">
			<DashboardAlertRowContent {...props} />
		</div>
	);
};
